import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { ENUMS } from '../../utils/constants';
import { checkOriginNonProd, isNullOrEmpty } from '../../utils/util';
import Breadcrumbs from '../../components/UI/Breadcrumbs';
import ListPaginationUl from '../../components/UI/ListPaginationUl';
import ButtonUI from '../../components/UI/ButtonUI';
import InventoryService from '../../services/InventoryService';
import PickingService from '../../services/PickingService';
import VolumeService from '../../services/VolumeService';
import ConfigurationService from '../../services/ConfigurationService';
import PlantService from '../../services/PlantService';
import ConversationService from '../../services/ConversationService';
import MessageService from '../../services/MessageService';
import ChangeLocationService from '../../services/ChangeLocationService';
import StockService from '../../services/StockService';
import { translate } from '../../utils/util';

const ServiceMonitor = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [services, setServices] = useState([{
        id: 1000, name: 'Configurações', status: true, service: props.configuration
    }, {
        id: 1001, name: 'Planta', status: true, service: props.plant
    }, {
        id: 1002, name: 'Comunication', status: true, service: props.comunication
    }, {
        id: 1004, name: 'Message', status: true, service: props.message
    }, {
        id: ENUMS.eModules.Inventory.value, name: ENUMS.eModules.Inventory.text, status: true, service: props.inventory
    }, {
        id: ENUMS.eModules.Picking.value, name: ENUMS.eModules.Picking.text, status: true, service: props.picking
    }, {
        id: ENUMS.eModules.PhysicalConfirmation.value, name: ENUMS.eModules.PhysicalConfirmation.text, status: true, service: props.receipt
    }, {
        id: ENUMS.eModules.Volume.value, name: ENUMS.eModules.Volume.text, status: true, service: props.volume
    }, {
        id: ENUMS.eModules.Location.value, name: ENUMS.eModules.Location.text, status: true, service: props.changeLocation
    }, {
        id: ENUMS.eModules.WarehouseManagement.value, name: ENUMS.eModules.WarehouseManagement.text, status: true, service: props.stock
    }]);

    useEffect(() => {
        services.forEach((item) => {
            if (item.service) {
                item.service((response) => {
                    const status = response.status === 200;
                    const message = !status ? response.message : "";
                    setStatus(item, status, message);
                });
            }
        })
        // eslint-disable-next-line
    }, []);

    const setStatus = (item, status, message) => {
        services.forEach((f) => {
            if (item.id === f.id) {
                f.status = status;
                f.message = message;
            }
        })
        let list = Object.assign([], services);
        setServices(list);
    }

    const onClick = () => {
        let a = document.createElement('a');
        a.target = '_blank';
        a.href = 'https://zabbix-frontend.devops.fcalatam.com.br/zabbix.php?action=dashboard.view&dashboardid=62';
        a.click();
    }

    const onClickCloudwatch = () => {
        let a = document.createElement('a');
        a.target = '_blank';
        a.href = checkOriginNonProd(window)
            ? 'https://cloudwatch.amazonaws.com/dashboard.html?dashboard=supplychain-logistics&context=eyJSIjoidXMtZWFzdC0xIiwiRCI6ImN3LWRiLTIzNDA2MTM1NzY2MSIsIlUiOiJ1cy1lYXN0LTFfWjNSbXZXVWd1IiwiQyI6ImlpcmlnbXJkNTd1bTk0Yjk5amdqNnBpdWMiLCJJIjoidXMtZWFzdC0xOmQzNDJiMDAyLTRjZDYtNGQxNS04NmI1LTQ3NDQwYjg3MGNiMiIsIk8iOiJhcm46YXdzOmlhbTo6MjM0MDYxMzU3NjYxOnJvbGUvc2VydmljZS1yb2xlL0Nsb3VkV2F0Y2hEYXNoYm9hcmQtUmVhZE9ubHlBY2Nlc3NXaXRoTG9ncy1zdXBwbHljaGFpbi0tQU5IOTRKUFYiLCJNIjoiVXNyUHdTaW5nbGUifQ%3D%3D'
            : 'https://cloudwatch.amazonaws.com/dashboard.html?dashboard=supplychain-logistics&context=eyJSIjoidXMtZWFzdC0xIiwiRCI6ImN3LWRiLTI3MDU3OTAzNzUxNSIsIlUiOiJ1cy1lYXN0LTFfYjdGaUcyQWpVIiwiQyI6IjFtbmJrN3AzNGxhNXIzNmlramRnZmNuMTgyIiwiSSI6InVzLWVhc3QtMTpmMTU2YWIxZi0wNjJkLTQwNTgtYjIyMy1jY2QyZWVkNzYxOWEiLCJPIjoiYXJuOmF3czppYW06OjI3MDU3OTAzNzUxNTpyb2xlL3NlcnZpY2Utcm9sZS9DbG91ZFdhdGNoRGFzaGJvYXJkLVJlYWRPbmx5QWNjZXNzLXN1cHBseWNoYWluLWxvZ2lzdGljLUVaSllMRU5ZIiwiTSI6IlVzclB3U2luZ2xlIn0%3D';
        a.click();
    }

    return (
        <div>
            <Breadcrumbs id="serviceLogistics" title={{ icon: "mdi mdi-clipboard-check-outline", label: translate('logistic-service', 'general') }} />
            <div className="container-fluid" style={{ marginTop: '10px', }}>
                <div className="container">
                    <div className="container-fluid" style={{ marginTop: '10px', }}>
                        <div id="ListItemsJustification" className="container-fluid">
                            <ListPaginationUl
                                page={0}
                                current={{ currentPage, setCurrentPage }}
                                data={services.map((item) => {
                                    return (
                                        <div className="row"
                                            style={{ display: 'block', marginBottom: '0px', marginLeft: '5px' }}                                        >
                                            <span className="title sixth-text-color col s12" style={{ color: !item.status ? "red" : "#757575" }}>
                                                {`${item.name} API`} {`${!item.status ? "NOK" : "OK"}`} {`${isNullOrEmpty(item.message) ? "" : item.message}`}
                                            </span>
                                        </div>
                                    );
                                })}
                            />
                        </div>
                    </div>
                    <div className="row" style={{ paddingTop: '1px' }}>
                        <ButtonUI full="true" text="Painel zabbix" onClick={onClick} />
                    </div>
                    <div className="row" style={{ paddingTop: '1px' }}>
                        <ButtonUI full="true" text="Cloudwatch" onClick={onClickCloudwatch} />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        volume: (callback) => {
            dispatch(VolumeService.live(callback));
        },
        picking: (callback) => {
            dispatch(PickingService.live(callback));
        },
        inventory: (callback) => {
            dispatch(InventoryService.live(callback));
        },
        configuration: (callback) => {
            dispatch(ConfigurationService.live(callback));
        },
        plant: (callback) => {
            dispatch(PlantService.live(callback));
        },
        comunication: (callback) => {
            dispatch(ConversationService.live(callback));
        },
        message: (callback) => {
            dispatch(MessageService.live(callback));
        },
        changeLocation: (callback) => {
            dispatch(ChangeLocationService.live(callback));
        },
        stock: (callback) => {
            dispatch(StockService.live(callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ServiceMonitor)));
